import { Observable } from 'rxjs';
import { switchMap, take } from 'rxjs/operators';
import { Injectable, Injector } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';

import {
  ACCOUNT_INFO_V2_REQUEST_URL,
  IDENTITY_EXCLUDED_URLS,
  ACCOUNT_INFO_V1_REQUEST_URL
} from '../constants/identity.constant';
import { TokenService } from '../services/token.service';
import { IdentityService } from '../services/identity.service';

@Injectable()
export class AccessTokenInterceptor implements HttpInterceptor {
  constructor(
    private injector: Injector,
    private tokenService: TokenService,
  ) {}

  public intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const shouldNotAttachAuthHeader = this.shouldNotAttachAuthHeader(request.url);
    if (shouldNotAttachAuthHeader) {
      return this.proceedUnauthorizedRequest(request, next);
    }

    const isAccountInfoRequest = request.url.startsWith(ACCOUNT_INFO_V1_REQUEST_URL()) ||
                                 request.url.startsWith(ACCOUNT_INFO_V2_REQUEST_URL());
    if (isAccountInfoRequest) {
      return this.proceedAuthorizedRequest(request, next);
    }

    const identityService = this.injector.get(IdentityService);
    return identityService.isAuthorized$.pipe(
      take(1),
      switchMap((isAuthorized) => isAuthorized
        ? this.proceedAuthorizedRequest(request, next)
        : this.proceedUnauthorizedRequest(request, next)
      ),
    );
  }

  private proceedAuthorizedRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(this.tokenService.addAuthorizationHeader(request));
  }

  private proceedUnauthorizedRequest(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    return next.handle(request);
  }

  private shouldNotAttachAuthHeader(requestUrl: string): boolean {
    return IDENTITY_EXCLUDED_URLS().some(excludedUrl => excludedUrl && requestUrl.startsWith(excludedUrl));
  }
}
